import { VacancyCard, VacancyCardMobile } from '@entities/vacancy';
import type { IVacancy } from '@entities/vacancy';

export interface IVacancyCardWrapperProps {
  vacancy: IVacancy;
  index: number;
  vacancies: IVacancy[];
  email: string;
}
export function VacancyCardWrapper({
  vacancy,
  index,
  vacancies,
  email,
}: IVacancyCardWrapperProps) {
  return (
    <>
      <VacancyCard
        vacancyEmail={email}
        vacancy={vacancy}
        vacancies={vacancies}
        index={index}
      />
      <VacancyCardMobile
        vacancyEmail={email}
        vacancy={vacancy}
        vacancies={vacancies}
      />
    </>
  );
}
